// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"74dc3e0d","453":"6e23e06e","667":"7158a066"}[chunkId] + ".chunk.js";
};